var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "app-main" },
    [
      _c(
        "transition",
        { attrs: { name: "fade-transform", mode: "out-in" } },
        [
          _c(
            "keep-alive",
            { attrs: { include: _vm.cachedViews, max: 20 } },
            [_c("router-view", { key: _vm.key })],
            1
          ),
        ],
        1
      ),
      _c(
        "wl-dialog",
        {
          ref: "dialog",
          attrs: {
            open: _vm.showModal,
            title: "异常详情",
            "ok-btn": null,
            "close-btn": null,
          },
          on: {
            "update:open": function ($event) {
              _vm.showModal = $event
            },
            close: _vm.closeModal,
          },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("p", [_vm._v(_vm._s(_vm.modalText))]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }